export enum Branch{
    HETAUDA = "hetauda",
    MAITIDEVI = "maitidevi"
}